import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import _imports_0 from '@/assets/login/logo_s.png';
const _hoisted_1 = {
  class: "panel-company flex-full"
};
import { useRoute, useRouter } from 'vue-router';
export default /*@__PURE__*/_defineComponent({
  __name: 'panel-company',
  setup(__props) {
    const route = useRoute();
    const router = useRouter();
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, _cache[0] || (_cache[0] = [_createElementVNode("img", {
        src: _imports_0,
        alt: ""
      }, null, -1)]));
    };
  }
});